import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ["You've tried every diet but the scale won't move", 'Your belly fat seems impossible to get rid of', 'You feel tired and sluggish all the time', 'Your metabolism feels completely broken', 'You feel like your body is working against you'];
  return <section className="bg-[#E8441A] py-16 lg:py-24 text-white" data-id="element-62">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-64">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-65">
            Does This Sound Like You?
          </h2>
        </motion.div>

        <div className="bg-white/10 rounded-2xl p-6 sm:p-10 backdrop-blur-sm border border-white/20 shadow-xl" data-id="element-66">
          <ul className="space-y-6" data-id="element-67">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 text-lg sm:text-xl font-medium" data-id="element-68">
                <XCircle className="shrink-0 text-white/80 mt-1" size={28} data-id="element-69" />
                <span data-id="element-70">{problem}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}